import { render, staticRenderFns } from "./demo-form.vue?vue&type=template&id=c24d4cd4&scoped=true&"
import script from "./demo-form.vue?vue&type=script&lang=js&"
export * from "./demo-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24d4cd4",
  null
  
)

export default component.exports